import useApp from "./useApp";
import CryptoJS from "crypto-js";

const SECRET_KEY = "secret-encryption-key";

function encryptToken(token) {
  return CryptoJS.AES.encrypt(token, SECRET_KEY).toString();
}

function decryptToken(cipherText) {
  const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
  return bytes.toString(CryptoJS.enc.Utf8);
}

function useLocalStorage() {
  const { setMember = () => {}, setToken = () => {} } = useApp();

  const setItem = (key, value) => {
    try {
      let v = value;

      if (value === null || value === undefined) {
        v = "null";
      } else if (typeof value === "object") {
        v = JSON.stringify(value);
      } else {
        v = value.toString();
      }

      localStorage.setItem(key, v);
      return true;
    } catch (e) {
      //console.log(e);
      return false;
    }
  };

  const getItem = (key) => {
    try {
      const value = localStorage.getItem(key);
      if (canConvertToObject(value)) {
        return JSON.parse(value);
      }
      if (value === "null") {
        return null;
      }
      return value;
    } catch (e) {
      //console.log(e);
      return false;
    }
  };

  const login = (data) => {
    if (data?.user) {
      setItem("member", data?.user);
    }
    if (data?.token) {
      let encrypted = encryptToken(data.token);
      setItem("token", encrypted);
    }
    setMember(data?.user || {});
    setToken(data?.token || null);
  };

  const memberInfo = () => {
    const member = getItem("member");
    let token = getItem("token");
    if (member) {
      setMember(member);
    }
    if (token) {
      token = decryptToken(token);
      setToken(token);
    }
    return { member, token };
  };

  function canConvertToObject(str) {
    try {
      let obj = JSON.parse(str);
      return typeof obj === "object" && obj !== null;
    } catch (e) {
      return false;
    }
  }

  return { setItem, getItem, login, memberInfo };
}

export default useLocalStorage;
